// extracted by mini-css-extract-plugin
module.exports = {"fsa":"styles_fsa__pVGDq"};